window.PluginManager?.register(
    'CobShippingPaymentSelectionPlugin',
    () => import('./shipping-payment-selection/cob-shipping-payment-selection-plugin.plugin'),
);
